var render = function render(){var _vm=this,_c=_vm._self._c;return (false)?_c('div',{staticClass:"footer-container"},[_vm._v(" footer ")]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }